<template>
    <div id="app" class="invisible">
        <nav-header class="nav-header"/>
        <nav-header-mobile class="nav-header"/>

        <div class="content-windows">
            <home/>
            <!--<product/>-->
            <service/>
            <technology/>
            <roadmap/>
            <!--<team/>-->
            <about-us/>
        </div>

        <div id="sc-page-footer">Copyright © 2019 Seal-SC All Rights Reserved.</div>
    </div>
</template>

<script>
  import NavHeader from "./components/nav/navHeader"
  import NavHeaderMobile from "./components/nav/navHeaderMobile"
  import SlideDot from "./components/nav/slideDot"
  import {drawWaves} from "./js/waves"
  import Home from "./views/home";
  import Service from "./views/service";
  import Technology from "./views/technology";
  import Roadmap from "./views/roadmap";
  import Team from "./views/team";
  import AboutUs from "./views/aboutUs";
  import Is from 'is_js'
  import {resizeContentWindow} from "./js/common";
  import Product from "./views/product";

  export default {
    components: {
      Product,
      AboutUs,
      Team,
      Roadmap,
      Technology,
      Service,
      Home,
      SlideDot,
      NavHeaderMobile,
      NavHeader
    },
    name: "app",
    mounted() {
      this.$nextTick(_=> {
        resizeContentWindow()
      })
    }
  }
</script>

<style>
    #app {
        font-family: "Avenir",Helvetica Neue,Helvetica,Arial,sans-serif !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        transition: all 1s;
        color: #161920;
    }

    #app.invisible {
        visibility: hidden;
        opacity: 0;
    }

    #app > div {
        margin: 0 auto;
    }

    #sc-page-waves {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        transition: all 0.6s;
    }

    html, body {
        background-color: #ffffff;
    }

    .page > div {
        width: 100%;
    }

    .clear::after {
        width: 0;
        height: 0;
        content: ' ';
        visibility: hidden;
        display: block;
        clear: both;
    }

    .container {
        width: 100%;
        max-width: 1280px;
        margin: 0 auto;
        /*padding-top: 160px;*/
        transition: all 0.4s;
        justify-content:center;
        align-items:center;
    }

    .container .window-title {
        text-align: center;
        font-size: 38px;
        line-height: 50px;
        color: #332f42;
        margin-bottom: 20px;
    }

    .nav-header {
        position: fixed;
        background-color: rgba(255, 255, 255, 0.95);
        top: 0;
    }

    .content-windows {
        z-index: 10000;
        position: relative;
        padding-top: 96px;

    }

    .content-window-container:nth-child(even) {
        background-color: #eff4f7;
    }

    #sc-page-footer {
        bottom: 0;
        left: 0;
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        color: #999;
        text-align: center;
        z-index: 20000;
        transition: all 0.6s;
        background-color: #eff4f7;
    }

    #sc-page-footer.odd {
        background-color: transparent;
    }
    #sc-page-footer.even {
        background-color: #eff4f7;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.4s ease;
    }
    .fade-enter, .fade-leave-to
        /* .component-fade-leave-active for below version 2.1.8 */ {
        opacity: 0;
    }

    @media screen and (max-width: 720px) {
        .container {
            padding: 20px;
            /*padding-top: 60px;*/
        }

        .container .window-title {
            font-size: 30px;
            line-height: 40px;
            margin-bottom: 20px;
        }

        .content-windows {
            /*position: fixed;*/
            width: 100%;
            padding-top: 42px;
        }
    }
</style>

<style>
    .window-content {
        display: flex;
        width: 100%;
        justify-content:center;
        flex-direction: row;
    }
    .window-subtitle {
        text-align: center;
        margin-bottom: 40px;
    }

    .window-content > .item {
        padding: 40px;
        flex: 1;
    }
    .window-content > div.item >  div {
        text-align: center;
    }

    .window-content > div.item >  div.icon > img {
        width: 128px;
    }

    .window-content > div.item >  div.title {
        font-size: 24px;
        padding: 20px;
    }

    .window-content > div.item >  div.desc {
        font-size: 16px;
        font-weight: 300;
    }

    @media screen and (max-width: 720px) {
        #sc-page-waves {
            opacity: 0.6;
        }
        .window-content {
            position: relative;
            display: block;
            width: 100%;
        }

        .window-content > .item {
            position: relative;
            flex: none;
            padding: 0;
        }

        .window-content > div.item >  div.icon,
        .window-content > div.item >  div.title {
            float: left;
        }

        .window-content > div.item >  div.icon {
            margin-left: 20%;
            /*left: 50%;*/
        }

        .window-content > div.item >  div.title {
            font-size: 20px;
            line-height: 74px;
            padding: 0;
            padding-left: 10px;
        }

        .window-content > div.item >  div.desc {
            clear: both;
            padding-top: 20px;
        }

        .window-content > div.item >  div.icon > img {
            width: 64px;
        }
    }
</style>


<style>
    /*=== Trigger  ===*/
    .will-animate {
        /*visibility: hidden;*/
        opacity: 0;
    }
    .will-animate.animated {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-animation-timing-function: ease;
        animation-timing-function: ease;

        visibility: visible;
    }

    /*=== Animations start here  ===*/
    /*=== FADE IN  ===*/
    @-webkit-keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }
    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    .fadeIn {
        -webkit-animation-name: fadeIn;
        animation-name: fadeIn;
    }

    @-webkit-keyframes fadeOut {
        from {
            opacity: 1;
        }

        to {
            opacity: 0;
        }
    }
    @keyframes fadeOut {
        from {
            opacity: 1;
        }

        to {
            opacity: 0;
        }
    }

    .fadeOut {
        -webkit-animation-name: fadeOut;
        animation-name: fadeOut;
    }


    /*=== FADE IN DOWN ===*/
    @-webkit-keyframes fadeInDown {
        from {
            opacity: 0;
            -webkit-transform: translate3d(0, -60px, 0);
            transform: translate3d(0, -60px, 0);
        }

        to {
            opacity: 1;
            -webkit-transform: none;
            transform: none;
        }
    }
    @keyframes fadeInDown {
        from {
            opacity: 0;
            -webkit-transform: translate3d(0, -60px, 0);
            transform: translate3d(0, -60px, 0);
        }

        to {
            opacity: 1;
            -webkit-transform: none;
            transform: none;
        }
    }

    .fadeInDown {
        -webkit-animation-name: fadeInDown;
        animation-name: fadeInDown;
    }

    /*==== FADE IN UP ===*/
    @-webkit-keyframes fadeInUp {
        from {
            opacity: 0;
            -webkit-transform: translate3d(0, 60px, 0);
            transform: translate3d(0, 60px, 0);
        }

        to {
            opacity: 1;
            -webkit-transform: none;
            transform: none;
        }
    }
    @keyframes fadeInUp {
        from {
            opacity: 0;
            -webkit-transform: translate3d(0, 60px, 0);
            transform: translate3d(0, 60px, 0);
        }

        to {
            opacity: 1;
            -webkit-transform: none;
            transform: none;
        }
    }

    .fadeInUp {
        -webkit-animation-name: fadeInUp;
        animation-name: fadeInUp;
    }

    /*=== FADE IN LEFT ===*/
    @-webkit-keyframes fadeInLeft {
        from {
            opacity: 0;
            -webkit-transform: translate3d(-60px, 0, 0);
            transform: translate3d(-60px, 0, 0);
        }

        to {
            opacity: 1;
            -webkit-transform: none;
            transform: none;
        }
    }
    @keyframes fadeInLeft {
        from {
            opacity: 0;
            -webkit-transform: translate3d(-60px, 0, 0);
            transform: translate3d(-60px, 0, 0);
        }

        to {
            opacity: 1;
            -webkit-transform: none;
            transform: none;
        }
    }

    .fadeInLeft {
        -webkit-animation-name: fadeInLeft;
        animation-name: fadeInLeft;
    }


    /*==== FADE IN RIGHT ===*/
    @-webkit-keyframes fadeInRight {
        from {
            opacity: 0;
            -webkit-transform: translate3d(60px, 0, 0);
            transform: translate3d(60px, 0, 0);
        }

        to {
            opacity: 1;
            -webkit-transform: none;
            transform: none;
        }
    }
    @keyframes fadeInRight {
        from {
            opacity: 0;
            -webkit-transform: translate3d(60px, 0, 0);
            transform: translate3d(60px, 0, 0);
        }

        to {
            opacity: 1;
            -webkit-transform: none;
            transform: none;
        }
    }

    .fadeInRight {
        -webkit-animation-name: fadeInRight;
        animation-name: fadeInRight;
    }
</style>